import { Component, Input, ChangeDetectionStrategy, ViewChildren, QueryList }  from '@angular/core';
import { LeoBox, ControlMessages, Spinner, Fees, CategoryForm, Modal } from "../../../ui-helper";
import { Observable } from "rxjs";
import { Store } from "@ngrx/store";
import { AppState, MessageState, CategoryFormState } from "../../../reducers"
import { CategoryActions, PriceLevelActions, CategoryFormActions, MessageActions } from "../../../actions"
import { Category, PriceLevel } from "../../../models"
import * as ui from "../../../models/ui"
import { CategoryApi, PriceApi, HttpClient } from "../../../services/webservice";
import { RoleService } from "../../../services";
const uuid = require("uuid")

@Component({
	selector: 'categories',
	templateUrl: "./categories.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	styles: [require("./categories.scss")]
})
export class CategoriesComponent {
	@ViewChildren(CategoryForm)
	categoryForms: QueryList<CategoryForm>

	protected globalFees$: Observable<ui.FeeCollection>
	protected displayGlobalFees$: Observable<boolean>
	protected categories$: Observable<Category[]>
	protected combinedPricelevels$: Observable<ui.CombinedPriceLevel[]>
	protected displayCategories$: Observable<ui.DisplayCategory[]>;
	protected displayGlobalFeeWarning$: Observable<boolean>;
	protected queryForceDelete$: Observable<ui.DisplayCategory>;
	protected queryForceDeletePriceLevel$: Observable<PriceLevel>;
	protected showSpinner$: Observable<boolean>;
	protected showFormErrors = false;
	hasMerchantMarketingRole: boolean = false;

	private collectionUrl;

	constructor(
		private priceLevelActions: PriceLevelActions,
		private categoryActions: CategoryActions,
		private categoryFormActions: CategoryFormActions,
		private messageActions: MessageActions,
		private roleService: RoleService,
		private store: Store<AppState>) {

		this.hasMerchantMarketingRole = this.roleService.hasUserRoles("MERCHANT, MARKETING") || this.roleService.hasUserRoles("SUPPORT")

		this.categories$ = this.store.select("eventServerState", "categories", "categories")

		this.combinedPricelevels$ = this.store.select("eventServerState", "priceLevels", "combinedPricelevels")

		this.displayCategories$ = this.store.select("categoryForm")
			.filter(state => state.updateUi).map(state => state.displayCategories);
		this.globalFees$ = this.store.select("categoryForm").filter(state => state.updateUi).map(state => state.globalFees);
		this.displayGlobalFees$ = this.store.select("categoryForm")
			.filter(state => state.updateUi).map(state => state.displayGlobalFees);
		this.displayGlobalFeeWarning$ = this.store.select("categoryForm", "displayGlobalFeeWarning")
		this.queryForceDelete$ = this.store.select("categoryForm", "queryForceDelete")
		this.queryForceDeletePriceLevel$ = this.store.select("categoryForm", "queryForceDeletePriceLevel")
		this.showSpinner$ = this.store.select("categoryForm", "loading")
		Observable.combineLatest(
			this.categories$,
			this.combinedPricelevels$,
			(categories, combinedPricelevels) => this.mergeCategoryWithCombinedPriceLevel(categories, combinedPricelevels)
		).subscribe(x => this.store.dispatch(this.categoryFormActions.newDisplayCategories(x)))

	}

	@Input() set categoryCollectionUrl(url: string) {
		this.collectionUrl = url;
		if (url)	this.store.dispatch(this.categoryActions.loadCollection(url));
	}

	protected displayCategoryChange(displayCategory: ui.DisplayCategory) {
		this.store.dispatch(this.categoryFormActions.displayCategoryChange(displayCategory));
	}
	protected addReducedPrice(categoryUUID: string) {
		this.store.dispatch(this.categoryFormActions.addReducedPriceLevel(categoryUUID));
	}

	protected addCategory() {
		this.store.dispatch(this.categoryFormActions.addDisplayCategory(null));
	}
	protected gloablFeeWarningYes() {
		this.store.dispatch(this.categoryFormActions.forceEmptyGlobalFees());
	}

	protected gloablFeeWarningNo() {
		this.store.dispatch(this.categoryFormActions.cancelGloablFeeWarning());
	}
	protected deleteCategory(displayCategory: ui.DisplayCategory) {
		this.store.dispatch(this.categoryFormActions.deleteCategory(displayCategory));
	}

	protected forceDeleteYes() {
		this.store.dispatch(this.categoryFormActions.forceCategoryDelete());
	}
	protected forceDeleteNo() {
		this.store.dispatch(this.categoryFormActions.cancelCategoryDelete());
	}

	protected forceDeletePriceLevelNo() {
		this.store.dispatch(this.categoryFormActions.cancelPriceLevelDelete());
	}
	protected forceDeletePriceLevelYes() {
		this.store.dispatch(this.categoryFormActions.forcePriceLevelDelete());
	}


	protected deletePriceLevel(pricelevel: PriceLevel, displayCategory: ui.DisplayCategory) {
		this.store.dispatch(this.categoryFormActions.deleteReducedPriceLevel(pricelevel, displayCategory))
	}

	protected save() {
		if (this.categoryForms.map(cf => cf.isValid()).reduce((a, b) => a && b)) {
			this.showFormErrors = false;
			this.store.dispatch(this.categoryFormActions.saveDisplayCategories(this.collectionUrl));
		} else {
			this.showFormErrors = true
			this.store.dispatch(this.messageActions.displayMessage("Bitte korrigieren Sie die rot umrandeten Felder.", "error"));
		}
	}

	protected toggleGlobalFees() {
		this.store.dispatch(this.categoryFormActions.toggleGlobalFees());
	}

	protected gloablFeesChange(feeCollection: ui.FeeCollection) {
		this.store.dispatch(this.categoryFormActions.newGlobalFees(feeCollection));
	}

	private mergeCategoryWithCombinedPriceLevel(categories: Category[], combinedPriceLevels: ui.CombinedPriceLevel[]): ui.DisplayCategory[] {
		let results = []
		for (let category of categories) {
			let foundCombinedPriceLevel = combinedPriceLevels.find(cpl => cpl.categoryID === category.uuid)
			if (foundCombinedPriceLevel) {
				let vats = [foundCombinedPriceLevel.standard.price.vat, ...foundCombinedPriceLevel.reduced.map(r => r.price.vat)]
				const allVatsAreTheSame = vats.every(v => v === vats[0])
				if (allVatsAreTheSame) {
					category.vat = vats[0];
				}
			}
			results.push({
				category: category,
				combinedPriceLevel: foundCombinedPriceLevel
			})
		}
		return results;
	}
}




// WEBPACK FOOTER //
// ./src/app/components/event-components/categories/categories.component.ts